var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAutoinvest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.0736V13.7978H7.27535M2 13.8691L6.07961 17.703C7.02456 18.6484 8.1936 19.3392 9.47769 19.7105C10.7617 20.082 11.6715 20.1418 11.6715 20.1418M21.6104 5.46768V10.7435M21.6104 10.7435H16.3351M21.6104 10.7435L21.343 10.352L17.2634 6.51814C16.3185 5.57263 15.1493 4.88193 13.8653 4.51048C9.89322 3.36149 5.58609 5.57462 4.20685 9.47264M14.3984 15.5995V18.4919C14.3984 19.5416 16.1 20.3925 18.1994 20.3925C20.2987 20.3925 22.0002 19.5416 22.0002 18.4919V15.5995M18.1992 17.4091C20.2983 17.4091 22 16.5582 22 15.5085C22 14.4589 20.2983 13.6078 18.1992 13.6078C16.0999 13.6078 14.3982 14.4589 14.3982 15.5085C14.3982 16.5582 16.0999 17.4091 18.1992 17.4091Z",
    stroke: "#04102A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoinvest);
export default __webpack_public_path__ + "static/media/autoinvest.357bb6ea.svg";
export { ForwardRef as ReactComponent };